import { useState, useCallback } from "react";
import { toast } from "sonner";

/**
 * useAttachments - Hook لإدارة المرفقات (صور وملفات)
 * @param {Function} t - دالة الترجمة
 */
export function useAttachments({ t }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageBase64, setImageBase64] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileSelect = useCallback((e, type) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (type === 'image' || type === 'camera' || file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result;
        setImagePreview(base64Data);
        setImageBase64(base64Data.split(',')[1]);
        setSelectedImage(file);
        toast.success(t("imageSelected"));
      };
      reader.onerror = () => {
        toast.error(t("imageReadError"));
      };
      reader.readAsDataURL(file);
    } else {
      setSelectedFile(file);
      toast.success(`${t("fileSelected") || "تم اختيار الملف"}: ${file.name}`);
    }
    
    e.target.value = '';
  }, [t]);

  const clearImage = useCallback(() => {
    setSelectedImage(null);
    setImagePreview(null);
    setImageBase64(null);
  }, []);

  const clearFile = useCallback(() => {
    setSelectedFile(null);
  }, []);

  const clearAll = useCallback(() => {
    clearImage();
    clearFile();
  }, [clearImage, clearFile]);

  return {
    selectedImage,
    imagePreview,
    imageBase64,
    selectedFile,
    handleFileSelect,
    clearImage,
    clearFile,
    clearAll
  };
}

export default useAttachments;
